import isEqual from "lodash/isEqual";
export function hasAbsTransformChanged(absoluteLocation, nodeData) {
    // TODO: Later, when we have generic type for AnyPcbNode, we should be able
    // to remove this force cast.
    const bakedRules = nodeData.bakedRules;
    const origAbsLocation = bakedRules?.positionRelativeToDocument;
    const origRelLocation = bakedRules?.positionRelativeToRootLayout;
    const origAbsRotation = bakedRules?.rotationRelativeToDocument;
    const origRelRotation = bakedRules?.rotationRelativeToRootLayout;
    const origAbsTransform = bakedRules?.transformRelativeToDocument;
    const origRelTransform = bakedRules?.transformRelativeToShapesLayer;
    return !(isEqual(absoluteLocation.positionRelativeToDocument, origRelLocation) &&
        isEqual(absoluteLocation.positionRelativeToRootLayout, origAbsLocation) &&
        isEqual(absoluteLocation.rotationRelativeToDocument, origAbsRotation) &&
        isEqual(absoluteLocation.rotationRelativeToRootLayout, origRelRotation) &&
        isEqual(absoluteLocation.transformRelativeToDocument, origAbsTransform) &&
        isEqual(absoluteLocation.transformRelativeToShapesLayer, origRelTransform));
}
//# sourceMappingURL=hasAbsTransformChanged.js.map